import { actionCreator } from 'utils';
import * as SegmentTypes from '../types/segmentTypes';

const initState = {
    loading: false,
    error: false,
    success: false,
    offset: 0,
    limit: 10,
    sort: {
        key: 'created_at',
        type: 'desc',
    },
    disable: false,
    listing: {},
    subSegments: {},
    add: {
        loading: false,
        error: false,
        success: false,
        current: 0,
    },
    edit: {
        loading: false,
        data: null,
        error: false,
        success: false,
    },
    filters: {
        name: '',
    },
};

export default function (state = initState, action) {
    switch (action.type) {
    case SegmentTypes.LOAD_SEGMENTS:
        return Object.assign({}, state, {
            loading: true,
        });

    case actionCreator(SegmentTypes.LOAD_SEGMENTS, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case actionCreator(SegmentTypes.LOAD_SEGMENTS, 'err'):
        return Object.assign({}, state, {
            loading: false,
            error: true,
        });

    case SegmentTypes.LOAD_EDITABLE_SEGMENT:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(SegmentTypes.LOAD_EDITABLE_SEGMENT, 'res'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                data: action.data,
            }),
        });

    case actionCreator(SegmentTypes.LOAD_EDITABLE_SEGMENT, 'err'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                error: true,
            }),
        });

    case SegmentTypes.SET_EMPTY_EDITABLE_SEGMENT:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                data: null,
                error: false,
            }),
        });

    case SegmentTypes.SET_SEGMENTS_FILTER:
        return Object.assign({}, state, {
            loading: true,
            filters: {
                ...state.filters,
                [action.key]: action.value,
            },
        });

    case actionCreator(SegmentTypes.SET_SEGMENTS_FILTER, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case SegmentTypes.SET_SEGMENT_PAGINATION:
        return Object.assign({}, state, {
            [action.key]: action.pagination,
        });

    case SegmentTypes.SET_SEGMENT_SORT:
        return Object.assign({}, state, {
            sort: action.sort,
        });

    case SegmentTypes.RESET_FILTER_SEGMENTS:
        return Object.assign({}, state, {
            ...state,
            loading: true,
            filters: {
                name: '',
            },
        });

    case actionCreator(SegmentTypes.RESET_FILTER_SEGMENTS, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case SegmentTypes.ADD_NEW_SEGMENT:
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(SegmentTypes.ADD_NEW_SEGMENT, 'res'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                loading: action.loading,
                error: false,
                success: action.success,
            }),
        });

    case actionCreator(SegmentTypes.ADD_NEW_SEGMENT, 'err'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                loading: false,
                error: action.error,
            }),
        });

    case SegmentTypes.EDIT_SEGMENT:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(SegmentTypes.EDIT_SEGMENT, 'res'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                success: action.success,
            }),
        });

    case actionCreator(SegmentTypes.EDIT_SEGMENT, 'err'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                error: true,
            }),
        });

    case SegmentTypes.TOGGLE_SEGMENT_STATUS:
        return Object.assign({}, state, {
            disable: action.value,
        });

    case SegmentTypes.LOAD_SUB_SEGMENTS:
        return Object.assign({}, state, {
            loading: true,
        });

    case actionCreator(SegmentTypes.LOAD_SUB_SEGMENTS, 'res'):
        return Object.assign({}, state, {
            loading: false,
            subSegments: action.data,
        });

    case actionCreator(SegmentTypes.LOAD_SUB_SEGMENTS, 'err'):
        return Object.assign({}, state, {
            loading: false,
            error: true,
        });

    default:
        return state;
    }
}
